module.exports = __webpack_public_path__ + "static/media/avatar-D_K.623a5c4d.png";